import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/laugh-beam': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM389.4 397.4C351.6 435.2 301.4 456 248 456S144.4 435.2 106.6 397.4 48 309.4 48 256 68.8 152.4 106.6 114.6 194.6 56 248 56 351.6 76.8 389.4 114.6 448 202.6 448 256 427.2 359.6 389.4 397.4zM328 152C304.2 152 275.3 181.3 272 223.4 271.3 232 282.8 235.3 286.9 227.9L296.4 210.9C304.1 197.2 315.6 189.3 327.9 189.3S351.7 197.2 359.4 210.9L368.9 227.9C373 235.3 384.5 231.9 383.8 223.4 380.7 181.3 351.8 152 328 152zM127 227.9L136.5 210.9C144.2 197.2 155.7 189.3 168 189.3S191.8 197.2 199.5 210.9L209 227.9C213.1 235.3 224.6 231.9 223.9 223.4 220.6 181.3 191.7 152 167.9 152S115.2 181.3 111.9 223.4C111.3 231.9 122.8 235.3 127 227.9zM362.4 288H133.6C125.4 288 119.1 295 120.1 303 127.6 362.2 179 408 241.2 408H254.8C317 408 368.4 362.2 375.9 303 376.9 295 370.6 288 362.4 288z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/laugh-beam.js
// module id = FFV6
// module chunks = 144